import type { FontSource } from 'expo-font';

import { fontFiles } from './font-files';
import type { FontsType } from './fonts-type';

interface FontAssetFamilyType {
  [key: string]: FontAsset;
}

type FontAssetFile = {
  [key: number]: [
    {
      [key: string]: FontSource;
    }
  ];
};

export const mapFontAssetFamilies = (
  initialValue: FontAssetFile,
  fontFamilies: FontAssetFamily[]
) =>
  fontFamilies.reduce(
    (prev, cur) => cur.mapToFontAssetFiles(prev),
    initialValue
  );

export class FontAsset {
  constructor(public fontFamily: string, public priority: number) {}

  public get assetFile() {
    return {
      [this.fontFamily]: fontFiles[this.fontFamily],
    };
  }
}

export class FontAssetFamily {
  constructor(private fonts: FontAssetFamilyType) {}

  public get getFontsType(): FontsType {
    const _fonts: Partial<FontsType> = {};
    Object.keys(this.fonts).forEach((key) => {
      _fonts[key] = {
        fontFamily: this.fonts[key].fontFamily,
      };
    });
    return _fonts as FontsType;
  }

  public mapToFontAssetFiles = (initialValue: FontAssetFile): FontAssetFile => {
    return Object.values(this.fonts).reduce((fontAssetFile, font) => {
      if (!fontAssetFile[font.priority]) {
        fontAssetFile[font.priority] = [font.assetFile];
      } else {
        fontAssetFile[font.priority].push(font.assetFile);
      }
      return fontAssetFile;
    }, initialValue);
  };
}
